/* tslint:disable */
/* eslint-disable */
/**
 * Zara.com Help section REST API
 * Rest API used to offer the help section content to frontend clients
 *
 * The version of the OpenAPI document: 1.2.0
 * Contact: lddzaraorder@inditex.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ApiError
 */
export interface ApiError {
    /**
     * 
     * @type {number}
     * @memberof ApiError
     */
    'action'?: number;
    /**
     * 
     * @type {number}
     * @memberof ApiError
     */
    'code'?: number;
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    'description'?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiError
     */
    'service'?: string;
}
/**
 * Article information
 * @export
 * @interface ArticleInfoResponse
 */
export interface ArticleInfoResponse {
    /**
     * Article Topic
     * @type {string}
     * @memberof ArticleInfoResponse
     */
    'topic'?: string;
    /**
     * 
     * @type {ContentInfo}
     * @memberof ArticleInfoResponse
     */
    'content'?: ContentInfo;
    /**
     * Array of Sections of the article
     * @type {Array<Section>}
     * @memberof ArticleInfoResponse
     */
    'sections'?: Array<Section>;
    /**
     * Array of related articles
     * @type {Array<ShortInfo>}
     * @memberof ArticleInfoResponse
     */
    'relatedArticles'?: Array<ShortInfo>;
    /**
     * Array of faqs
     * @type {Array<ContentInfo>}
     * @memberof ArticleInfoResponse
     */
    'faqs'?: Array<ContentInfo>;
}
/**
 * block section info contained in marketing spot
 * @export
 * @interface BlockSectionResponse
 */
export interface BlockSectionResponse {
    /**
     * Value with the list of ids for the block section
     * @type {Array<string>}
     * @memberof BlockSectionResponse
     */
    'ids'?: Array<string>;
}
/**
 * Content Response
 * @export
 * @interface Content
 */
export interface Content {
    /**
     * Array of ContentManagerComponents used by frontend clients
     * @type {Array<ContentManagerComponents>}
     * @memberof Content
     */
    'components'?: Array<ContentManagerComponents>;
}
/**
 * Information of a content displayed to the customers
 * @export
 * @interface ContentBodyInfo
 */
export interface ContentBodyInfo {
    /**
     * Type value of the Content
     * @type {string}
     * @memberof ContentBodyInfo
     */
    'type'?: string;
    /**
     * Identifier of the content displayed
     * @type {string}
     * @memberof ContentBodyInfo
     */
    'contentId'?: string;
    /**
     * 
     * @type {Content}
     * @memberof ContentBodyInfo
     */
    'content'?: Content;
}
/**
 * Information for any information displayed to the customers
 * @export
 * @interface ContentInfo
 */
export interface ContentInfo {
    /**
     * Title of the content
     * @type {string}
     * @memberof ContentInfo
     */
    'title'?: string;
    /**
     * document identifier
     * @type {string}
     * @memberof ContentInfo
     */
    'id'?: string;
    /**
     * 
     * @type {ContentBodyInfo}
     * @memberof ContentInfo
     */
    'body'?: ContentBodyInfo;
}
/**
 * Content Manager Components
 * @export
 * @interface ContentManagerComponents
 */
export interface ContentManagerComponents {
    /**
     * datatype description
     * @type {string}
     * @memberof ContentManagerComponents
     */
    'datatype'?: string;
    /**
     * datatype description
     * @type {boolean}
     * @memberof ContentManagerComponents
     */
    'withDividers'?: boolean;
    /**
     * datatype description
     * @type {boolean}
     * @memberof ContentManagerComponents
     */
    'allowMultiple'?: boolean;
    /**
     * datatype description
     * @type {boolean}
     * @memberof ContentManagerComponents
     */
    'withIcon'?: boolean;
    /**
     * type
     * @type {string}
     * @memberof ContentManagerComponents
     */
    'type'?: string;
    /**
     * value
     * @type {string}
     * @memberof ContentManagerComponents
     */
    'value'?: string;
    /**
     * priority
     * @type {string}
     * @memberof ContentManagerComponents
     */
    'priority'?: string;
    /**
     * message
     * @type {string}
     * @memberof ContentManagerComponents
     */
    'message'?: string;
    /**
     * 
     * @type {ContentManagerComponentsText}
     * @memberof ContentManagerComponents
     */
    'text'?: ContentManagerComponentsText;
    /**
     * 
     * @type {ContentManagerComponentsText}
     * @memberof ContentManagerComponents
     */
    'author'?: ContentManagerComponentsText;
    /**
     * array of content items
     * @type {Array<ContentManagerComponentsItems>}
     * @memberof ContentManagerComponents
     */
    'items'?: Array<ContentManagerComponentsItems>;
    /**
     * array of content sections
     * @type {Array<ContentManagerComponentsSection>}
     * @memberof ContentManagerComponents
     */
    'sections'?: Array<ContentManagerComponentsSection>;
    /**
     * array of media items
     * @type {Array<ContentManagerComponentsXmedia>}
     * @memberof ContentManagerComponents
     */
    'media'?: Array<ContentManagerComponentsXmedia>;
}
/**
 * content manager item
 * @export
 * @interface ContentManagerComponentsItems
 */
export interface ContentManagerComponentsItems {
    /**
     * content manager item id
     * @type {number}
     * @memberof ContentManagerComponentsItems
     */
    'id'?: number;
    /**
     * datatype component item
     * @type {string}
     * @memberof ContentManagerComponentsItems
     */
    'datatype'?: string;
    /**
     * component item title
     * @type {string}
     * @memberof ContentManagerComponentsItems
     */
    'title'?: string;
    /**
     * component item url
     * @type {string}
     * @memberof ContentManagerComponentsItems
     */
    'url'?: string;
    /**
     * component item icon
     * @type {string}
     * @memberof ContentManagerComponentsItems
     */
    'icon'?: string;
    /**
     * 
     * @type {ContentManagerComponentsText}
     * @memberof ContentManagerComponentsItems
     */
    'text'?: ContentManagerComponentsText;
    /**
     * 
     * @type {ContentManagerComponentsText}
     * @memberof ContentManagerComponentsItems
     */
    'description'?: ContentManagerComponentsText;
    /**
     * component item reference
     * @type {string}
     * @memberof ContentManagerComponentsItems
     */
    'reference'?: string;
    /**
     * array of media items
     * @type {Array<ContentManagerComponentsXmedia>}
     * @memberof ContentManagerComponentsItems
     */
    'xmedia'?: Array<ContentManagerComponentsXmedia>;
}
/**
 * content manager section
 * @export
 * @interface ContentManagerComponentsSection
 */
export interface ContentManagerComponentsSection {
    /**
     * datatype component section
     * @type {string}
     * @memberof ContentManagerComponentsSection
     */
    'datatype'?: string;
    /**
     * 
     * @type {ContentManagerComponentsText}
     * @memberof ContentManagerComponentsSection
     */
    'title'?: ContentManagerComponentsText;
    /**
     * component section content
     * @type {Array<ContentManagerComponents>}
     * @memberof ContentManagerComponentsSection
     */
    'content'?: Array<ContentManagerComponents>;
}
/**
 * content manager component text
 * @export
 * @interface ContentManagerComponentsText
 */
export interface ContentManagerComponentsText {
    /**
     * datatype component text
     * @type {string}
     * @memberof ContentManagerComponentsText
     */
    'datatype'?: string;
    /**
     * value
     * @type {string}
     * @memberof ContentManagerComponentsText
     */
    'value'?: string;
}
/**
 * content manager xmedia
 * @export
 * @interface ContentManagerComponentsXmedia
 */
export interface ContentManagerComponentsXmedia {
    /**
     * datatype media item
     * @type {string}
     * @memberof ContentManagerComponentsXmedia
     */
    'datatype'?: string;
    /**
     * type media item
     * @type {string}
     * @memberof ContentManagerComponentsXmedia
     */
    'type'?: string;
    /**
     * height media item
     * @type {number}
     * @memberof ContentManagerComponentsXmedia
     */
    'height'?: number;
    /**
     * kind media item
     * @type {string}
     * @memberof ContentManagerComponentsXmedia
     */
    'kind'?: string;
    /**
     * name media item
     * @type {string}
     * @memberof ContentManagerComponentsXmedia
     */
    'name'?: string;
    /**
     * path media item
     * @type {string}
     * @memberof ContentManagerComponentsXmedia
     */
    'path'?: string;
    /**
     * 
     * @type {number}
     * @memberof ContentManagerComponentsXmedia
     */
    'set'?: number;
    /**
     * timestamp media item
     * @type {number}
     * @memberof ContentManagerComponentsXmedia
     */
    'timestamp'?: number;
    /**
     * allowed screens for media item
     * @type {Array<string>}
     * @memberof ContentManagerComponentsXmedia
     */
    'allowedScreens'?: Array<string>;
    /**
     * width media item
     * @type {number}
     * @memberof ContentManagerComponentsXmedia
     */
    'width'?: number;
    /**
     * extraInfo media item
     * @type {string}
     * @memberof ContentManagerComponentsXmedia
     */
    'extraInfo'?: string;
}
/**
 * 
 * @export
 * @interface HelpInfoFaqResponse
 */
export interface HelpInfoFaqResponse {
    /**
     * 
     * @type {Array<ContentInfo>}
     * @memberof HelpInfoFaqResponse
     */
    'faqs'?: Array<ContentInfo>;
}
/**
 * 
 * @export
 * @interface HelpInfoFavoritesResponse
 */
export interface HelpInfoFavoritesResponse {
    /**
     * 
     * @type {Array<ShortInfo>}
     * @memberof HelpInfoFavoritesResponse
     */
    'favorites'?: Array<ShortInfo>;
}
/**
 * 
 * @export
 * @interface HelpInfoRelatedArticleResponse
 */
export interface HelpInfoRelatedArticleResponse {
    /**
     * 
     * @type {Array<ShortInfo>}
     * @memberof HelpInfoRelatedArticleResponse
     */
    'relatedArticles'?: Array<ShortInfo>;
}
/**
 * 
 * @export
 * @interface HelpInfoRequest
 */
export interface HelpInfoRequest {
    /**
     * Key prefix for internationalize the response. Used like \'key.name\', \'key.title\', etc...
     * @type {string}
     * @memberof HelpInfoRequest
     */
    'key': string;
    /**
     * Contains the name of the marketing spot with the information to show
     * @type {string}
     * @memberof HelpInfoRequest
     */
    'marketingSpot': string;
    /**
     * Information about the icons used to ilustrate this node
     * @type {Array<XmediaRequest>}
     * @memberof HelpInfoRequest
     */
    'xmedia': Array<XmediaRequest>;
    /**
     * Topic asociated to this kind of information
     * @type {string}
     * @memberof HelpInfoRequest
     */
    'topic': string;
    /**
     * Store identifiers where the node will be showed
     * @type {Array<number>}
     * @memberof HelpInfoRequest
     */
    'showedIn'?: Array<number>;
}
/**
 * 
 * @export
 * @interface HelpInfoResponse
 */
export interface HelpInfoResponse {
    /**
     * Unique identifier of the node
     * @type {number}
     * @memberof HelpInfoResponse
     */
    'id': number;
    /**
     * Title of the information contained on this node
     * @type {string}
     * @memberof HelpInfoResponse
     */
    'name'?: string;
    /**
     * Key prefix for internationalize the response. Used like \'key.name\', \'key.title\', etc...
     * @type {string}
     * @memberof HelpInfoResponse
     */
    'key'?: string;
    /**
     * Contains the name of the marketing spot with the information to show
     * @type {string}
     * @memberof HelpInfoResponse
     */
    'marketingSpot'?: string;
    /**
     * Children of this node with more information related
     * @type {Array<HelpInfoResponse>}
     * @memberof HelpInfoResponse
     */
    'sections'?: Array<HelpInfoResponse>;
    /**
     * Information about the icons used to ilustrate this node
     * @type {Array<XmediaResponse>}
     * @memberof HelpInfoResponse
     */
    'xmedia'?: Array<XmediaResponse>;
    /**
     * 
     * @type {SeoResponse}
     * @memberof HelpInfoResponse
     */
    'seo'?: SeoResponse;
    /**
     * Topic asociated to this kind of information
     * @type {string}
     * @memberof HelpInfoResponse
     */
    'topic'?: string;
}
/**
 * 
 * @export
 * @interface HelpInfoResponseIOP
 */
export interface HelpInfoResponseIOP {
    /**
     * Unique identifier of the node
     * @type {number}
     * @memberof HelpInfoResponseIOP
     */
    'id': number;
    /**
     * Title of the information contained on this node
     * @type {string}
     * @memberof HelpInfoResponseIOP
     */
    'name'?: string;
    /**
     * type of node
     * @type {string}
     * @memberof HelpInfoResponseIOP
     */
    'type'?: string;
    /**
     * Key prefix for internationalize the response. Used like \'key.name\', \'key.title\', etc...
     * @type {string}
     * @memberof HelpInfoResponseIOP
     */
    'key'?: string;
    /**
     * Contains the name of the marketing spot with the information to show
     * @type {string}
     * @memberof HelpInfoResponseIOP
     */
    'marketingSpot'?: string;
    /**
     * Children of this node with more information related
     * @type {Array<HelpInfoResponseIOP>}
     * @memberof HelpInfoResponseIOP
     */
    'sections'?: Array<HelpInfoResponseIOP>;
    /**
     * Information about the icons used to ilustrate this node
     * @type {Array<XmediaResponse>}
     * @memberof HelpInfoResponseIOP
     */
    'xmedia'?: Array<XmediaResponse>;
    /**
     * 
     * @type {SeoResponse}
     * @memberof HelpInfoResponseIOP
     */
    'seo'?: SeoResponse;
    /**
     * Topic asociated to this kind of information
     * @type {string}
     * @memberof HelpInfoResponseIOP
     */
    'topic'?: string;
    /**
     * Sections contained in the marketing spot
     * @type {Array<BlockSectionResponse>}
     * @memberof HelpInfoResponseIOP
     */
    'blockSections'?: Array<BlockSectionResponse>;
    /**
     * Sections contained in the marketing spot
     * @type {Array<RelatedArticlesResponse>}
     * @memberof HelpInfoResponseIOP
     */
    'relatedArticles'?: Array<RelatedArticlesResponse>;
    /**
     * Words used by searcher engine to find the related article
     * @type {Array<string>}
     * @memberof HelpInfoResponseIOP
     */
    'keywords'?: Array<string>;
}
/**
 * 
 * @export
 * @interface HelpTreeListResponseV2
 */
export interface HelpTreeListResponseV2 {
    /**
     * 
     * @type {Array<HelpInfoResponseIOP>}
     * @memberof HelpTreeListResponseV2
     */
    'helpTreeDocuments'?: Array<HelpInfoResponseIOP>;
}
/**
 * 
 * @export
 * @interface HelpTreeResponse
 */
export interface HelpTreeResponse {
    /**
     * 
     * @type {Array<HelpInfoResponse>}
     * @memberof HelpTreeResponse
     */
    'helpTree'?: Array<HelpInfoResponse>;
}
/**
 * 
 * @export
 * @interface HelpTreeResponseIOP
 */
export interface HelpTreeResponseIOP {
    /**
     * 
     * @type {Array<HelpInfoResponseIOP>}
     * @memberof HelpTreeResponseIOP
     */
    'helpTree'?: Array<HelpInfoResponseIOP>;
}
/**
 * related articles and FAQs
 * @export
 * @interface RelatedArticlesResponse
 */
export interface RelatedArticlesResponse {
    /**
     * type
     * @type {string}
     * @memberof RelatedArticlesResponse
     */
    'nodeType'?: string;
    /**
     * related articles ids
     * @type {Array<string>}
     * @memberof RelatedArticlesResponse
     */
    'ids'?: Array<string>;
}
/**
 * Section information
 * @export
 * @interface Section
 */
export interface Section {
    /**
     * 
     * @type {ContentInfo}
     * @memberof Section
     */
    'content'?: ContentInfo;
    /**
     * Section identifier
     * @type {string}
     * @memberof Section
     */
    'sectionId'?: string;
    /**
     * Section type
     * @type {string}
     * @memberof Section
     */
    'type'?: string;
}
/**
 * Information for SEO
 * @export
 * @interface SeoResponse
 */
export interface SeoResponse {
    /**
     * Value to define the key word
     * @type {string}
     * @memberof SeoResponse
     */
    'keyword'?: string;
    /**
     * Value with the title of the node
     * @type {string}
     * @memberof SeoResponse
     */
    'title'?: string;
    /**
     * Value to usa as a metadescription of the page
     * @type {string}
     * @memberof SeoResponse
     */
    'metaDescription'?: string;
}
/**
 * Link information for sections showed to the customer
 * @export
 * @interface ShortInfo
 */
export interface ShortInfo {
    /**
     * Id of the content
     * @type {string}
     * @memberof ShortInfo
     */
    'id'?: string;
    /**
     * title showed of the content
     * @type {string}
     * @memberof ShortInfo
     */
    'title'?: string;
}
/**
 * 
 * @export
 * @interface XmediaRequest
 */
export interface XmediaRequest {
    /**
     * Name of the file which contains the xmedia
     * @type {string}
     * @memberof XmediaRequest
     */
    'name': string;
    /**
     * Array with the size of the screens for using this xmedia
     * @type {Array<string>}
     * @memberof XmediaRequest
     */
    'allowedScreens': Array<string>;
    /**
     * Data type of the element. Default value \'xmedia\'
     * @type {string}
     * @memberof XmediaRequest
     */
    'datatype'?: string;
    /**
     * Type of the xmedia. Default value \'vector\'
     * @type {string}
     * @memberof XmediaRequest
     */
    'type'?: string;
    /**
     * Kind of xmedia. Default value \'other\'
     * @type {string}
     * @memberof XmediaRequest
     */
    'kind'?: string;
    /**
     * path where the resource is located. Default value \'/mkt/misc/help/icons/\'
     * @type {string}
     * @memberof XmediaRequest
     */
    'path'?: string;
}
/**
 * 
 * @export
 * @interface XmediaResponse
 */
export interface XmediaResponse {
    /**
     * data type of the element
     * @type {string}
     * @memberof XmediaResponse
     */
    'datatype'?: string;
    /**
     * type of the xmedia
     * @type {string}
     * @memberof XmediaResponse
     */
    'type'?: string;
    /**
     * kind of xmedia
     * @type {string}
     * @memberof XmediaResponse
     */
    'kind'?: string;
    /**
     * path where the resource is located
     * @type {string}
     * @memberof XmediaResponse
     */
    'path'?: string;
    /**
     * name of the file which contains the xmedia
     * @type {string}
     * @memberof XmediaResponse
     */
    'name'?: string;
    /**
     * timestamp of the creation of the xmedia
     * @type {string}
     * @memberof XmediaResponse
     */
    'timestamp'?: string;
    /**
     * Array with the size of the screens for using this xmedia
     * @type {Array<string>}
     * @memberof XmediaResponse
     */
    'allowedScreens'?: Array<string>;
}

/**
 * ArticleContentApi - axios parameter creator
 * @export
 */
export const ArticleContentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the FAQ info of a given store and article
         * @summary Get article FAQs Info
         * @param {string} idStore The store identifier
         * @param {string} articleId The article identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleFaqs: async (idStore: string, articleId: string, locale: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idStore' is not null or undefined
            assertParamExists('getArticleFaqs', 'idStore', idStore)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('getArticleFaqs', 'articleId', articleId)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('getArticleFaqs', 'locale', locale)
            const localVarPath = `/itxrest/1/help/store/{idStore}/article/{articleId}/faqs`
                .replace(`{${"idStore"}}`, encodeURIComponent(String(idStore)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the Article info of a given store and section
         * @summary Get Article Info
         * @param {number} idStore The store identifier
         * @param {string} articleId The Article identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleInfo: async (idStore: number, articleId: string, locale: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idStore' is not null or undefined
            assertParamExists('getArticleInfo', 'idStore', idStore)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('getArticleInfo', 'articleId', articleId)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('getArticleInfo', 'locale', locale)
            const localVarPath = `/itxrest/1/help/store/{idStore}/article/{articleId}`
                .replace(`{${"idStore"}}`, encodeURIComponent(String(idStore)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the related-articles info of a given store and a given article
         * @summary Get Related Articles Info for an article
         * @param {number} idStore The store identifier
         * @param {string} articleId The article identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleRelatedArticles: async (idStore: number, articleId: string, locale: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idStore' is not null or undefined
            assertParamExists('getArticleRelatedArticles', 'idStore', idStore)
            // verify required parameter 'articleId' is not null or undefined
            assertParamExists('getArticleRelatedArticles', 'articleId', articleId)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('getArticleRelatedArticles', 'locale', locale)
            const localVarPath = `/itxrest/1/help/store/{idStore}/article/{articleId}/related-articles`
                .replace(`{${"idStore"}}`, encodeURIComponent(String(idStore)))
                .replace(`{${"articleId"}}`, encodeURIComponent(String(articleId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the favorite articles for a given store
         * @summary Get the favorite articles for a given store
         * @param {string} storeId The store identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreFavorites: async (storeId: string, locale: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('getStoreFavorites', 'storeId', storeId)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('getStoreFavorites', 'locale', locale)
            const localVarPath = `/itxrest/1/help/store/{storeId}/favorites`
                .replace(`{${"storeId"}}`, encodeURIComponent(String(storeId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ArticleContentApi - functional programming interface
 * @export
 */
export const ArticleContentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ArticleContentApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the FAQ info of a given store and article
         * @summary Get article FAQs Info
         * @param {string} idStore The store identifier
         * @param {string} articleId The article identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleFaqs(idStore: string, articleId: string, locale: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HelpInfoFaqResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArticleFaqs(idStore, articleId, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the Article info of a given store and section
         * @summary Get Article Info
         * @param {number} idStore The store identifier
         * @param {string} articleId The Article identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleInfo(idStore: number, articleId: string, locale: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArticleInfoResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArticleInfo(idStore, articleId, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the related-articles info of a given store and a given article
         * @summary Get Related Articles Info for an article
         * @param {number} idStore The store identifier
         * @param {string} articleId The article identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getArticleRelatedArticles(idStore: number, articleId: string, locale: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HelpInfoRelatedArticleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getArticleRelatedArticles(idStore, articleId, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the favorite articles for a given store
         * @summary Get the favorite articles for a given store
         * @param {string} storeId The store identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getStoreFavorites(storeId: string, locale: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HelpInfoFavoritesResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getStoreFavorites(storeId, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * ArticleContentApi - factory interface
 * @export
 */
export const ArticleContentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ArticleContentApiFp(configuration)
    return {
        /**
         * Returns the FAQ info of a given store and article
         * @summary Get article FAQs Info
         * @param {string} idStore The store identifier
         * @param {string} articleId The article identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleFaqs(idStore: string, articleId: string, locale: string, options?: any): AxiosPromise<HelpInfoFaqResponse> {
            return localVarFp.getArticleFaqs(idStore, articleId, locale, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the Article info of a given store and section
         * @summary Get Article Info
         * @param {number} idStore The store identifier
         * @param {string} articleId The Article identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleInfo(idStore: number, articleId: string, locale: string, options?: any): AxiosPromise<ArticleInfoResponse> {
            return localVarFp.getArticleInfo(idStore, articleId, locale, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the related-articles info of a given store and a given article
         * @summary Get Related Articles Info for an article
         * @param {number} idStore The store identifier
         * @param {string} articleId The article identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getArticleRelatedArticles(idStore: number, articleId: string, locale: string, options?: any): AxiosPromise<HelpInfoRelatedArticleResponse> {
            return localVarFp.getArticleRelatedArticles(idStore, articleId, locale, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the favorite articles for a given store
         * @summary Get the favorite articles for a given store
         * @param {string} storeId The store identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getStoreFavorites(storeId: string, locale: string, options?: any): AxiosPromise<HelpInfoFavoritesResponse> {
            return localVarFp.getStoreFavorites(storeId, locale, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ArticleContentApi - interface
 * @export
 * @interface ArticleContentApi
 */
export interface ArticleContentApiInterface {
    /**
     * Returns the FAQ info of a given store and article
     * @summary Get article FAQs Info
     * @param {string} idStore The store identifier
     * @param {string} articleId The article identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleContentApiInterface
     */
    getArticleFaqs(idStore: string, articleId: string, locale: string, options?: AxiosRequestConfig): AxiosPromise<HelpInfoFaqResponse>;

    /**
     * Returns the Article info of a given store and section
     * @summary Get Article Info
     * @param {number} idStore The store identifier
     * @param {string} articleId The Article identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleContentApiInterface
     */
    getArticleInfo(idStore: number, articleId: string, locale: string, options?: AxiosRequestConfig): AxiosPromise<ArticleInfoResponse>;

    /**
     * Returns the related-articles info of a given store and a given article
     * @summary Get Related Articles Info for an article
     * @param {number} idStore The store identifier
     * @param {string} articleId The article identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleContentApiInterface
     */
    getArticleRelatedArticles(idStore: number, articleId: string, locale: string, options?: AxiosRequestConfig): AxiosPromise<HelpInfoRelatedArticleResponse>;

    /**
     * Returns the favorite articles for a given store
     * @summary Get the favorite articles for a given store
     * @param {string} storeId The store identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleContentApiInterface
     */
    getStoreFavorites(storeId: string, locale: string, options?: AxiosRequestConfig): AxiosPromise<HelpInfoFavoritesResponse>;

}

/**
 * ArticleContentApi - object-oriented interface
 * @export
 * @class ArticleContentApi
 * @extends {BaseAPI}
 */
export class ArticleContentApi extends BaseAPI implements ArticleContentApiInterface {
    /**
     * Returns the FAQ info of a given store and article
     * @summary Get article FAQs Info
     * @param {string} idStore The store identifier
     * @param {string} articleId The article identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleContentApi
     */
    public getArticleFaqs(idStore: string, articleId: string, locale: string, options?: AxiosRequestConfig) {
        return ArticleContentApiFp(this.configuration).getArticleFaqs(idStore, articleId, locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the Article info of a given store and section
     * @summary Get Article Info
     * @param {number} idStore The store identifier
     * @param {string} articleId The Article identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleContentApi
     */
    public getArticleInfo(idStore: number, articleId: string, locale: string, options?: AxiosRequestConfig) {
        return ArticleContentApiFp(this.configuration).getArticleInfo(idStore, articleId, locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the related-articles info of a given store and a given article
     * @summary Get Related Articles Info for an article
     * @param {number} idStore The store identifier
     * @param {string} articleId The article identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleContentApi
     */
    public getArticleRelatedArticles(idStore: number, articleId: string, locale: string, options?: AxiosRequestConfig) {
        return ArticleContentApiFp(this.configuration).getArticleRelatedArticles(idStore, articleId, locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the favorite articles for a given store
     * @summary Get the favorite articles for a given store
     * @param {string} storeId The store identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ArticleContentApi
     */
    public getStoreFavorites(storeId: string, locale: string, options?: AxiosRequestConfig) {
        return ArticleContentApiFp(this.configuration).getStoreFavorites(storeId, locale, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * BuyingGuideApi - axios parameter creator
 * @export
 */
export const BuyingGuideApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the help information tree of a given store
         * @summary Get Help Info V2
         * @param {string} idStore The store identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompleteTreeIOPVO: async (idStore: string, locale: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idStore' is not null or undefined
            assertParamExists('getCompleteTreeIOPVO', 'idStore', idStore)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('getCompleteTreeIOPVO', 'locale', locale)
            const localVarPath = `/itxrest/2/help/store/{idStore}`
                .replace(`{${"idStore"}}`, encodeURIComponent(String(idStore)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the help information tree of a given store
         * @summary Get Help Info
         * @param {string} idStore The store identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCompleteTreeVO: async (idStore: string, locale: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idStore' is not null or undefined
            assertParamExists('getCompleteTreeVO', 'idStore', idStore)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('getCompleteTreeVO', 'locale', locale)
            const localVarPath = `/itxrest/1/help/store/{idStore}`
                .replace(`{${"idStore"}}`, encodeURIComponent(String(idStore)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * BuyingGuideApi - functional programming interface
 * @export
 */
export const BuyingGuideApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = BuyingGuideApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the help information tree of a given store
         * @summary Get Help Info V2
         * @param {string} idStore The store identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCompleteTreeIOPVO(idStore: string, locale: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HelpTreeResponseIOP>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompleteTreeIOPVO(idStore, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the help information tree of a given store
         * @summary Get Help Info
         * @param {string} idStore The store identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        async getCompleteTreeVO(idStore: string, locale: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HelpTreeResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCompleteTreeVO(idStore, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * BuyingGuideApi - factory interface
 * @export
 */
export const BuyingGuideApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = BuyingGuideApiFp(configuration)
    return {
        /**
         * Returns the help information tree of a given store
         * @summary Get Help Info V2
         * @param {string} idStore The store identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCompleteTreeIOPVO(idStore: string, locale: string, options?: any): AxiosPromise<HelpTreeResponseIOP> {
            return localVarFp.getCompleteTreeIOPVO(idStore, locale, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the help information tree of a given store
         * @summary Get Help Info
         * @param {string} idStore The store identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @deprecated
         * @throws {RequiredError}
         */
        getCompleteTreeVO(idStore: string, locale: string, options?: any): AxiosPromise<HelpTreeResponse> {
            return localVarFp.getCompleteTreeVO(idStore, locale, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * BuyingGuideApi - interface
 * @export
 * @interface BuyingGuideApi
 */
export interface BuyingGuideApiInterface {
    /**
     * Returns the help information tree of a given store
     * @summary Get Help Info V2
     * @param {string} idStore The store identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyingGuideApiInterface
     */
    getCompleteTreeIOPVO(idStore: string, locale: string, options?: AxiosRequestConfig): AxiosPromise<HelpTreeResponseIOP>;

    /**
     * Returns the help information tree of a given store
     * @summary Get Help Info
     * @param {string} idStore The store identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof BuyingGuideApiInterface
     */
    getCompleteTreeVO(idStore: string, locale: string, options?: AxiosRequestConfig): AxiosPromise<HelpTreeResponse>;

}

/**
 * BuyingGuideApi - object-oriented interface
 * @export
 * @class BuyingGuideApi
 * @extends {BaseAPI}
 */
export class BuyingGuideApi extends BaseAPI implements BuyingGuideApiInterface {
    /**
     * Returns the help information tree of a given store
     * @summary Get Help Info V2
     * @param {string} idStore The store identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof BuyingGuideApi
     */
    public getCompleteTreeIOPVO(idStore: string, locale: string, options?: AxiosRequestConfig) {
        return BuyingGuideApiFp(this.configuration).getCompleteTreeIOPVO(idStore, locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the help information tree of a given store
     * @summary Get Help Info
     * @param {string} idStore The store identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @deprecated
     * @throws {RequiredError}
     * @memberof BuyingGuideApi
     */
    public getCompleteTreeVO(idStore: string, locale: string, options?: AxiosRequestConfig) {
        return BuyingGuideApiFp(this.configuration).getCompleteTreeVO(idStore, locale, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * SectionContentApi - axios parameter creator
 * @export
 */
export const SectionContentApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the related article info for a section
         * @summary Get Related Articles Info
         * @param {number} idStore The store identifier
         * @param {string} sectionId The Section identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedArticles: async (idStore: number, sectionId: string, locale: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idStore' is not null or undefined
            assertParamExists('getRelatedArticles', 'idStore', idStore)
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('getRelatedArticles', 'sectionId', sectionId)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('getRelatedArticles', 'locale', locale)
            const localVarPath = `/itxrest/1/help/store/{idStore}/section/{sectionId}/related-articles`
                .replace(`{${"idStore"}}`, encodeURIComponent(String(idStore)))
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Returns the FAQ info of a given section
         * @summary Get FAQ Info
         * @param {number} idStore The store identifier
         * @param {string} sectionId The Section identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectionFaqs: async (idStore: number, sectionId: string, locale: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'idStore' is not null or undefined
            assertParamExists('getSectionFaqs', 'idStore', idStore)
            // verify required parameter 'sectionId' is not null or undefined
            assertParamExists('getSectionFaqs', 'sectionId', sectionId)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('getSectionFaqs', 'locale', locale)
            const localVarPath = `/itxrest/1/help/store/{idStore}/section/{sectionId}/faqs`
                .replace(`{${"idStore"}}`, encodeURIComponent(String(idStore)))
                .replace(`{${"sectionId"}}`, encodeURIComponent(String(sectionId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * SectionContentApi - functional programming interface
 * @export
 */
export const SectionContentApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = SectionContentApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the related article info for a section
         * @summary Get Related Articles Info
         * @param {number} idStore The store identifier
         * @param {string} sectionId The Section identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getRelatedArticles(idStore: number, sectionId: string, locale: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HelpInfoRelatedArticleResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getRelatedArticles(idStore, sectionId, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Returns the FAQ info of a given section
         * @summary Get FAQ Info
         * @param {number} idStore The store identifier
         * @param {string} sectionId The Section identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getSectionFaqs(idStore: number, sectionId: string, locale: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<HelpInfoFaqResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getSectionFaqs(idStore, sectionId, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * SectionContentApi - factory interface
 * @export
 */
export const SectionContentApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = SectionContentApiFp(configuration)
    return {
        /**
         * Returns the related article info for a section
         * @summary Get Related Articles Info
         * @param {number} idStore The store identifier
         * @param {string} sectionId The Section identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getRelatedArticles(idStore: number, sectionId: string, locale: string, options?: any): AxiosPromise<HelpInfoRelatedArticleResponse> {
            return localVarFp.getRelatedArticles(idStore, sectionId, locale, options).then((request) => request(axios, basePath));
        },
        /**
         * Returns the FAQ info of a given section
         * @summary Get FAQ Info
         * @param {number} idStore The store identifier
         * @param {string} sectionId The Section identifier
         * @param {string} locale The locale requested
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getSectionFaqs(idStore: number, sectionId: string, locale: string, options?: any): AxiosPromise<HelpInfoFaqResponse> {
            return localVarFp.getSectionFaqs(idStore, sectionId, locale, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * SectionContentApi - interface
 * @export
 * @interface SectionContentApi
 */
export interface SectionContentApiInterface {
    /**
     * Returns the related article info for a section
     * @summary Get Related Articles Info
     * @param {number} idStore The store identifier
     * @param {string} sectionId The Section identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectionContentApiInterface
     */
    getRelatedArticles(idStore: number, sectionId: string, locale: string, options?: AxiosRequestConfig): AxiosPromise<HelpInfoRelatedArticleResponse>;

    /**
     * Returns the FAQ info of a given section
     * @summary Get FAQ Info
     * @param {number} idStore The store identifier
     * @param {string} sectionId The Section identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectionContentApiInterface
     */
    getSectionFaqs(idStore: number, sectionId: string, locale: string, options?: AxiosRequestConfig): AxiosPromise<HelpInfoFaqResponse>;

}

/**
 * SectionContentApi - object-oriented interface
 * @export
 * @class SectionContentApi
 * @extends {BaseAPI}
 */
export class SectionContentApi extends BaseAPI implements SectionContentApiInterface {
    /**
     * Returns the related article info for a section
     * @summary Get Related Articles Info
     * @param {number} idStore The store identifier
     * @param {string} sectionId The Section identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectionContentApi
     */
    public getRelatedArticles(idStore: number, sectionId: string, locale: string, options?: AxiosRequestConfig) {
        return SectionContentApiFp(this.configuration).getRelatedArticles(idStore, sectionId, locale, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Returns the FAQ info of a given section
     * @summary Get FAQ Info
     * @param {number} idStore The store identifier
     * @param {string} sectionId The Section identifier
     * @param {string} locale The locale requested
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof SectionContentApi
     */
    public getSectionFaqs(idStore: number, sectionId: string, locale: string, options?: AxiosRequestConfig) {
        return SectionContentApiFp(this.configuration).getSectionFaqs(idStore, sectionId, locale, options).then((request) => request(this.axios, this.basePath));
    }
}


